import type { OrgaMembership } from "@/lib/auth/auth.types";
import { BaseApiClient } from "@/lib/api/baseApiClient.service";
import type { Organization } from "./organization.types";

/**
 * Service for managing organization-related operations
 */
class OrganizationService {
	private static instance: OrganizationService;
	private baseApi: BaseApiClient;

	private constructor() {
		this.baseApi = BaseApiClient.getInstance();
	}

	public static getInstance(): OrganizationService {
		if (!OrganizationService.instance) {
			OrganizationService.instance = new OrganizationService();
		}
		return OrganizationService.instance;
	}

	/**
	 * Fetches the user's organization memberships from the session
	 * @returns Promise with the user's organization memberships
	 */
	public async getUserOrganizations(): Promise<OrgaMembership[]> {
		return this.baseApi.get<OrgaMembership[]>("/session/organizations", {
			_t: Date.now(),
		}); // cache busting to avoid caching the organization memberships
	}

	/**
	 * Will return the organization details for the given organization id
	 * @param organizationId The id of the organization to fetch the details for
	 * @returns Promise with the organization details
	 */
	public async getOrganizationDetails(
		organizationId: string,
	): Promise<Organization> {
		return this.baseApi.get<Organization>(
			`/organization/${organizationId}/details`,
			{ _t: Date.now() }, // cache busting to avoid caching the organization details
		);
	}
}

export default OrganizationService;
